import {BaseService} from "./base";
import {HOSID} from "../config";

class SystemService extends BaseService {
  constructor() {
    super();
  }
  /**
   * 系统参数
   * @param key
   * @returns {Promise<{}>}
   */
  async key(key, hosId=HOSID, defaultString='1') {
      const { code, obj } = await this.$http('smarthos.system.param.string', {
          key, defaultString, hosId
      });
      if (code === '0') return obj;
  }

  /**
   * 医院列表
   * @returns {Promise<Array>}
   */
  async hosList() {
    const {code, list = []} = await this.$http('smarthos.system.hos.list', {});
    return code === '0' ? list : [];
  }

  /**
   * 科室列表
   * @param hosId
   * @returns {Promise<void>}
   */
  async deptList(hosId) {
    const {code, list = []} = await this.$http('smarthos.system.dept.list', {hosId});
    return code === '0' ? list : [];
  }

  /**
   * 医生列表
   * @param deptId
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async docList(deptId, pageNum = 1, pageSize = 1000,docType = 'DOC') {
    const {code, list = []} = await this.$http('smarthos.user.doc.list', {deptId, pageNum, pageSize,docType});
    return code === '0' ? list : [];
  }

  /**
   * 找医生
   * @param deptId
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async findDoc({deptId, pageNum = 1, pageSize = 1000}) {
    const {list = [], code, page = {}} = await this.$http('smarthos.user.doc.search', {deptId, pageSize, pageNum});
    return code === '0' ? {list, page} : {};
  }

  /**
   * 地区列表
   * @param areaCode
   * @param areaLevel
   * @returns {Promise<void>}
   */
  async areaList(areaCode = null, areaLevel = null) {
    const {code, obj = []} = await this.$http('smarthos.system.area.list', {areaCode, areaLevel});
    return code === '0' ? obj : [];
  }

  /**
   * 地区获得
   * @param areaCode
   * @returns {Promise<string>}
   */
  async areaGet(areaCode) {
    const {code, obj} = await this.$http('smarthos.system.area.get', {areaCode})
    return code === '0' ? obj : '';
  }

  /**
   * 获得完整地区id
   * @param areaCode
   * @returns {Promise<*[]>}
   */
  async getAllAreaCode(areaCode) {
    let list = await this.areaList();
    let ret = [areaCode], isGo = true;
    while (isGo === true) {
      const {superId} = list.find(r => r.id === areaCode);
      if (superId.length > 0) {
        ret.unshift(superId);
        areaCode = superId;
      } else isGo = false;
    }
    return ret;
  }

  /**
   * 医生名片
   * @param docId
   * @returns {Promise<void>}
   */
  async docCard(docId) {
    const {code, obj = {}} = await this.$http('smarthos.user.doc.card.get', {
      docId
    });
    return code === '0' ? obj : {};
  }

  /**
  * 医生拒绝理由
  * @param dicName
  * @returns {Promise<{}>}
  */
  async refuseReason(dicName) {
      const {code, list = []} = await this.$http('smarthos.system.dictionary.list', {
          dicName,
          hosId:HOSID
      });
      return code === '0' ? list : [];
  }

}

export const systemService = new SystemService();
